export default __webpack_public_path__ + "static/media/xpo-r.b69912b7.svg";